/* src/app/modules/shared/components/questions-form/questions-form.component.scss */
.button-row {
  margin-bottom: 30px;
}
/*# sourceMappingURL=questions-form.component.css.map */
